import { globalState } from './globalState'
import { log } from './utils'
import { createCustomizationUrl } from './utils/url'

type LemonstandConfig = {
    css: string
    js: string
    unreadOfferNotifsCountUrl: string
}

export const preResolveConfig = (): void => {
    if (typeof fetch !== 'function') {
        return
    }
    const originalCustomUrl = createCustomizationUrl()
    let resolvedUrl = ''
    fetch(originalCustomUrl)
        .then((resp) => {
            const currentCustomUrl = createCustomizationUrl()
            if (currentCustomUrl === originalCustomUrl) {
                // this is the latest, we keep it
                resolvedUrl = resp.url
                log('parsed customization url is ' + resolvedUrl)
                globalState.updateStore({
                    resolvedCustomizationUrl: resolvedUrl,
                })
                return resp.json()
            }
        })
        .then((config: LemonstandConfig | undefined) => {
            if (config) {
                globalState.updateStore({
                    unreadOfferNotifsCountUrl: config.unreadOfferNotifsCountUrl || '',
                })
            }
        })
}
